// extracted by mini-css-extract-plugin
module.exports = {"root":"g_M","profileCard":"g_N","profileImageWrapper":"g_P","profileImage":"g_Q","badges":"g_R","bio":"g_S"};